import { render, staticRenderFns } from "./AppraisalForm.vue?vue&type=template&id=c98b6952&scoped=true"
import script from "./AppraisalForm.vue?vue&type=script&lang=js"
export * from "./AppraisalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98b6952",
  null
  
)

export default component.exports